module.exports = __webpack_public_path__ + "img/icon-american-express.abd46e67.svg";